module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/RW-f2e685437e57ae79ff01bf8e85574994.png";